import styled from "styled-components";

const HomeGuideBannerWrapper = styled.div`
  position: relative;
  padding: 0 16px;

  > span {
    position absolute;
    top: 32px;
    left: 20px;
  }

  p {
    font-weight: 700;
    font-size: 1.25rem;
  }

  img {
    display: block;
    height: 160px;
    background-color: gray;
    margin-top: 24px;
    border-radius: 12px;
    overflow: hidden;
  }
  
  .dots_custom {
    display: inline-block;
    vertical-align: middle;
    margin: auto 0;
    padding: 0;
  }
  
  .dots_custom li {
    list-style: none;
    cursor: pointer;
    display: inline-block;
    margin: 0 3px;
    padding: 0;
  }
  
  .dots_custom li button {
    border: none;
    background: #4A505680;
    color: transparent;
    cursor: pointer;
    display: block;
    height: 4px;
    width: 4px;
    border-radius: 100%;
    padding: 0;
  }
  
  .dots_custom li.slick-active button {
    background-color: #F8F9FA;
  }

`;

export { HomeGuideBannerWrapper };
